unit uLogin;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Login,
  WEBLib.Storage, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Imaging.jpeg,
  WEBLib.Buttons, WEBLib.REST, WEBLib.JSON, WEBLib.JsonData, uHTTPHelper, uGlobal;

type
  TfrmLogin = class(TForm)
    WebImageControl1: TImageControl;
    WebPanel1: TPanel;
    lbUser: TLabel;
    edUser: TEdit;
    lbPw: TLabel;
    edPw: TEdit;
    btLogin: TButton;
    lbRegister: TLabel;
    reqLogin: THttpRequest;
    procedure WebLoginPanel1Login(Sender: TObject);
    [async]
    procedure btLoginClick(Sender: TObject); async;
    procedure edPwKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebFormCreate(Sender: TObject);
    [async]
    procedure lbRegisterClick(Sender: TObject); async;
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }

    [async]
    procedure AutologinIfPossible; async;
    [async]
    procedure OpenMainForm; async;
  protected procedure LoadDFMValues; override; end;

var
  frmLogin: TfrmLogin;

implementation

uses
  uRegister, uMain;

{$R *.dfm}

procedure TfrmLogin.AutologinIfPossible;
var
  ls: TLocalStorage;
  status: integer;
  jo: TJSONObject;
begin
  //Prüft ob ein Autologin möglich ist, wenn Access-Token und Refresh-Token
  //vorhanden und ein AuthTest-Call erfolgreich ist
  ls := TLocalStorage.Create(nil);
  try
    if (ls.GetValue('accesstoken') <> '') and (ls.GetValue('refreshtoken') <> '') then
    begin
      //Autologin mit hinterlegten Daten
      status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/testauth/', httpGET, '', jo));
      if (status = HTTP_OK) then
        OpenMainForm;
    end;

  finally
    ls.free;
  end;
end;

procedure TfrmLogin.btLoginClick(Sender: TObject);
var
  jo: TJSONObject;
  req: TJSXMLHttpRequest;
  jvUserID, jvUserName, jvAccessToken, jvRefreshToken, jvExpiresIn: TJSONValue;
  ls: TLocalStorage;
begin
  jo := TJSONObject.Create;
  jo.AddPair('username', edUser.Text);
  jo.AddPair('password', edPw.Text);
  reqLogin.Headers.Clear;
  reqLogin.PostData := jo.ToJSON;
  req := await(TJSXMLHttpRequest, reqLogin.Perform());
  jo.free;

  if (req.Status = HTTP_OK) then
  begin
    //Login erfolgreich
    jo := TJSONObject.ParseJSONValue(string(req.response)) as TJSONObject;
    jvUserID := jo.GetValue('userid');
    jvUserName := jo.GetValue('username');
    jvAccessToken := jo.GetValue('accesstoken');
    jvRefreshToken := jo.GetValue('refreshtoken');
    jvExpiresIn := jo.GetValue('expires_in');

    if not assigned(jvUserID) or not assigned(jvUserName) or not assigned(jvAccessToken)
       or not assigned(jvRefreshToken) or not assigned(jvExpiresIn) then
    begin
      ShowMessage('Fehler bei Antwort des Servers');
      exit;
    end;

    //Werte in Localstorage übertragen
    ls := TLocalStorage.Create(nil);
    try
      ls.SetValue('userid', jvUserID.Value);
      ls.SetValue('username', jvUsername.Value);
      ls.SetValue('accesstoken', jvAccessToken.Value);
      ls.SetValue('expires_in', jvExpiresIn.Value);
      ls.SetValue('refreshtoken', jvRefreshToken.Value);

      edUser.Text := '';
      edPw.Text := '';

      OpenMainForm;

    finally
      ls.free;
    end;

  end else
    ShowMessage('Fehler bei Anmeldung: ' + string(req.response));


end;

procedure TfrmLogin.edPwKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if (Key = VK_RETURN) then
    btLogin.Click;

end;

procedure TfrmLogin.lbRegisterClick(Sender: TObject);
var
  frmRegister: TFrmRegister;
begin
  frmRegister := TFrmRegister.Create(self);
  frmRegister.Popup := False;

  Await(TfrmRegister, frmRegister.Load());

  try
    Await(TfrmRegister, frmRegister.Execute);
    if (frmRegister.edPw.Text = '') then //war erfolgreich
    begin
      edUser.Text := frmRegister.edUser.Text; //Benutzername übernehmen in's Login
      edPw.SetFocus;
    end;
  finally
    frmRegister.free;
  end;
end;

procedure TfrmLogin.OpenMainForm;
var
  frmMain: TFrmMain;
begin
  //Mainform öffnen
  frmMain := TFrmMain.Create(self);
  frmMain.Popup := False;
  Await(TfrmMain, frmMain.Load());

  try
    Await(TfrmMain, frmMain.Execute);
    //Hier wurde Mainform geschlossen
    edUser.SetFocus;
  finally
    frmMain.free;
  end;
end;

procedure TfrmLogin.WebFormCreate(Sender: TObject);
begin
  reqLogin.URL := F1BET_SERVER + '/userlogin/';
  AutologinIfPossible;
end;

procedure TfrmLogin.WebLoginPanel1Login(Sender: TObject);
var
  LStorage: TLocalStorage;
begin
  LStorage := TLocalStorage.Create(nil);
  try
  //  LStorage.SetValue('user', WebLoginPanel1.User);
  finally
    LStorage.free;
  end;
end;

procedure TfrmLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  lbUser := TLabel.Create(Self);
  lbPw := TLabel.Create(Self);
  lbRegister := TLabel.Create(Self);
  edUser := TEdit.Create(Self);
  edPw := TEdit.Create(Self);
  btLogin := TButton.Create(Self);
  reqLogin := THttpRequest.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbUser.BeforeLoadDFMValues;
  lbPw.BeforeLoadDFMValues;
  lbRegister.BeforeLoadDFMValues;
  edUser.BeforeLoadDFMValues;
  edPw.BeforeLoadDFMValues;
  btLogin.BeforeLoadDFMValues;
  reqLogin.BeforeLoadDFMValues;
  try
    Name := 'frmLogin';
    Width := 368;
    Height := 629;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 0;
    WebImageControl1.Top := 0;
    WebImageControl1.Width := 368;
    WebImageControl1.Height := 629;
    WebImageControl1.ElementClassName := 'backgroundpic';
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.Align := alClient;
    WebImageControl1.ChildOrder := 1;
    WebImageControl1.Picture.LoadFromFile('uLogin.WebImageControl1.Picture.jpg');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 65;
    WebPanel1.Top := 171;
    WebPanel1.Width := 238;
    WebPanel1.Height := 286;
    WebPanel1.Center.Horizontal := True;
    WebPanel1.Center.Vertical := True;
    WebPanel1.ElementClassName := 'loginpanel';
    WebPanel1.ChildOrder := 1;
    WebPanel1.Color := 33023;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -12;
    WebPanel1.Font.Name := 'Tahoma';
    WebPanel1.Font.Style := [];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 0;
    lbUser.SetParentComponent(WebPanel1);
    lbUser.Name := 'lbUser';
    lbUser.Left := 24;
    lbUser.Top := 32;
    lbUser.Width := 100;
    lbUser.Height := 18;
    lbUser.Caption := 'Benutzername';
    lbUser.Font.Charset := DEFAULT_CHARSET;
    lbUser.Font.Color := clWindowText;
    lbUser.Font.Height := -16;
    lbUser.Font.Name := 'Tahoma, Arial, sans-serif';
    lbUser.Font.Style := [];
    lbUser.HeightPercent := 100.000000000000000000;
    lbUser.ParentFont := False;
    lbUser.WidthPercent := 100.000000000000000000;
    lbPw.SetParentComponent(WebPanel1);
    lbPw.Name := 'lbPw';
    lbPw.Left := 24;
    lbPw.Top := 104;
    lbPw.Width := 65;
    lbPw.Height := 18;
    lbPw.Caption := 'Passwort';
    lbPw.Font.Charset := DEFAULT_CHARSET;
    lbPw.Font.Color := clWindowText;
    lbPw.Font.Height := -16;
    lbPw.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPw.Font.Style := [];
    lbPw.HeightPercent := 100.000000000000000000;
    lbPw.ParentFont := False;
    lbPw.WidthPercent := 100.000000000000000000;
    lbRegister.SetParentComponent(WebPanel1);
    lbRegister.Name := 'lbRegister';
    lbRegister.Left := 24;
    lbRegister.Top := 256;
    lbRegister.Width := 149;
    lbRegister.Height := 18;
    lbRegister.Caption := 'Neues Konto anlegen';
    lbRegister.Font.Charset := DEFAULT_CHARSET;
    lbRegister.Font.Color := clBlue;
    lbRegister.Font.Height := -16;
    lbRegister.Font.Name := 'Tahoma, Arial, sans-serif';
    lbRegister.Font.Style := [];
    lbRegister.HeightPercent := 100.000000000000000000;
    lbRegister.ParentFont := False;
    lbRegister.WidthPercent := 100.000000000000000000;
    SetEvent(lbRegister, Self, 'OnClick', 'lbRegisterClick');
    edUser.SetParentComponent(WebPanel1);
    edUser.Name := 'edUser';
    edUser.Left := 24;
    edUser.Top := 64;
    edUser.Width := 193;
    edUser.Height := 28;
    edUser.ChildOrder := 1;
    edUser.ElementClassName := 'edit';
    edUser.Font.Charset := DEFAULT_CHARSET;
    edUser.Font.Color := clWindowText;
    edUser.Font.Height := -16;
    edUser.Font.Name := 'Tahoma, Arial, sans-serif';
    edUser.Font.Style := [];
    edUser.HeightPercent := 100.000000000000000000;
    edUser.ParentFont := False;
    edUser.WidthPercent := 100.000000000000000000;
    SetEvent(edUser, Self, 'OnKeyDown', 'edPwKeyDown');
    edPw.SetParentComponent(WebPanel1);
    edPw.Name := 'edPw';
    edPw.Left := 24;
    edPw.Top := 136;
    edPw.Width := 193;
    edPw.Height := 28;
    edPw.ChildOrder := 1;
    edPw.ElementClassName := 'edit';
    edPw.Font.Charset := DEFAULT_CHARSET;
    edPw.Font.Color := clWindowText;
    edPw.Font.Height := -19;
    edPw.Font.Name := 'Tahoma, Arial, sans-serif';
    edPw.Font.Style := [];
    edPw.HeightPercent := 100.000000000000000000;
    edPw.ParentFont := False;
    edPw.PasswordChar := '*';
    edPw.WidthPercent := 100.000000000000000000;
    SetEvent(edPw, Self, 'OnKeyDown', 'edPwKeyDown');
    btLogin.SetParentComponent(WebPanel1);
    btLogin.Name := 'btLogin';
    btLogin.Left := 24;
    btLogin.Top := 200;
    btLogin.Width := 193;
    btLogin.Height := 33;
    btLogin.Caption := 'Login';
    btLogin.ChildOrder := 4;
    btLogin.ElementClassName := 'loginbutton';
    btLogin.Font.Charset := DEFAULT_CHARSET;
    btLogin.Font.Color := clWindowText;
    btLogin.Font.Height := -16;
    btLogin.Font.Name := 'Tahoma, Arial, sans-serif';
    btLogin.Font.Style := [];
    btLogin.HeightPercent := 100.000000000000000000;
    btLogin.ParentFont := False;
    btLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btLogin, Self, 'OnClick', 'btLoginClick');
    reqLogin.SetParentComponent(Self);
    reqLogin.Name := 'reqLogin';
    reqLogin.Command := httpPOST;
    reqLogin.URL := 'http://localhost:1999/userlogin/';
    reqLogin.Left := 292;
    reqLogin.Top := 112;
  finally
    WebImageControl1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbUser.AfterLoadDFMValues;
    lbPw.AfterLoadDFMValues;
    lbRegister.AfterLoadDFMValues;
    edUser.AfterLoadDFMValues;
    edPw.AfterLoadDFMValues;
    btLogin.AfterLoadDFMValues;
    reqLogin.AfterLoadDFMValues;
  end;
end;

end.